import {
    componentStyles,
    Text,
    HeadingMedium,
    VerticalStack,
    Image,
    useColors,
} from "@mallardbay/lib-react-components"
import React from "react"

import SupportLink, { TYPES } from "~components/shared/support-link"
import COPY from "~config/copy-constants"

interface Props {
    readonly title: string
    readonly description?: string
    readonly supportMessage: string
    readonly bottomMessage?: string
    readonly imageSrc?: string
}

export default function SupportNotice({
    title,
    description,
    supportMessage,
    bottomMessage,
    imageSrc,
}: Props) {
    const styles = useStyles()

    return (
        <VerticalStack style={styles.root}>
            <VerticalStack style={styles.content}>
                <HeadingMedium style={styles.title}>{title}</HeadingMedium>
                {description && <Text>{description}</Text>}
                <VerticalStack style={styles.contactContainer}>
                    <Text style={styles.supportMessage}>{supportMessage}</Text>
                    <SupportLink
                        type={TYPES.EMAIL}
                        copyPrefix={COPY.EMAIL_PREFIX}
                        isUnderlined
                    />
                    <SupportLink
                        type={TYPES.PHONE}
                        copyPrefix={COPY.PHONE_PREFIX}
                        isUnderlined
                    />
                </VerticalStack>
                {bottomMessage && <Text>{bottomMessage}</Text>}
            </VerticalStack>
            {imageSrc && <Image style={styles.image} src={imageSrc} />}
        </VerticalStack>
    )
}

function useStyles() {
    const colors = useColors()

    return componentStyles({
        root: {
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
        },
        title: {
            color: colors.brandDefault,
        },
        content: {
            gap: 5,
            alignItems: "center",
        },
        contactContainer: {
            gap: 1,
            alignItems: "center",
        },
        image: {
            maxHeight: "180px",
        },
        supportMessage: {
            marginBottom: 2,
        },
    })
}
